import { Logger, LogLevel } from '@repo/utils/common';

import type { AppLocale } from '@/shared/configs/app.config';
import { getApiUrl, makeZodSafeFetchWithRefreshToken } from '@/shared/utils/common.utils';
import { menuTreeToMachineGroups } from '@/shared/utils/machine.utils';
import { machineListResultSchema } from '@/shared/validation/machine.validation';

const logger = new Logger(LogLevel.DEBUG);

export const getMachineList = async (locale: AppLocale) => {
  try {
    const data = await makeZodSafeFetchWithRefreshToken(
      getApiUrl('/menu-tree?type=1', locale),
      machineListResultSchema,
      { credentials: 'include' },
    );

    if (!data) {
      throw new Error('No machine list found');
    }

    return { machineGroups: menuTreeToMachineGroups(data) };
  } catch (error) {
    logger.error(error);
    throw new Error('Failed to fetch machine list');
  }
};
